import { Action } from 'redux';
import { productPageActionPrefix } from 'views/ProductPage/actions';

export const SELECT_ADDON = `${productPageActionPrefix}SELECT_ADDON`;
export const UNSELECT_ADDON = `${productPageActionPrefix}UNSELECT_ADDON`;
export const RESET_ADDON_GROUP = `${productPageActionPrefix}RESET_ADDON_GROUP`;

export interface AddonActionPayload extends AddonGroupActionPayload {
  productId: string;
  amount: number;
}

export interface AddonGroupActionPayload {
  groupKey: string;
}

export interface AddonAction extends Action, AddonActionPayload {}
export interface AddonGroupAction extends Action, AddonGroupActionPayload {}

export const selectAddon = (payload: AddonActionPayload): AddonAction => ({
  ...payload,
  type: SELECT_ADDON
});

export const unselectAddon = (payload: AddonActionPayload): AddonAction => ({
  ...payload,
  type: UNSELECT_ADDON
});

export const resetAddonGroup = (payload: AddonGroupActionPayload): AddonGroupAction => ({
  ...payload,
  type: RESET_ADDON_GROUP
});
